var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineClass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_52)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#paint0_linear_101_52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9966 15.1186C56.9966 14.5034 56.5266 14 55.9374 14H28.0568C27.4724 14 27 14.5034 27 15.1186V22.489C27.6331 23.1297 28.1761 23.9076 28.534 24.8992L28.8311 24.678C28.9188 24.589 29.0186 24.5254 29.1136 24.4517V16.2398H54.883V35.7551H29.1136V33.6525L27.0024 35.1627V36.8788C27.0024 37.4966 27.4748 38 28.0592 38C28.0592 38 52.6136 38 54.8611 38C57.1135 38 56.999 36.6551 56.999 36.6551V15.1186H56.9966Z",
    fill: "url(#paint1_linear_101_52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21C18.9853 21 21 18.9853 21 16.5C21 14.0147 18.9853 12 16.5 12C14.0147 12 12 14.0147 12 16.5C12 18.9853 14.0147 21 16.5 21Z",
    fill: "url(#paint2_linear_101_52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2616 89.9265L67.8458 88.1446L67.1968 87.5232L64.22 84.6822C60.6601 81.2706 56.6976 82.6048 53.0425 85.9023L53.0059 85.9353L52.7936 86.1915C52.3349 86.1052 51.4345 85.8516 50.8831 85.078C50.3292 84.2942 50.0879 81.7736 49.3884 84.6822C49.5397 84.0532 52.5083 50.7433 52.562 50.2461H59.1792C61.5167 50.2461 63.4028 48.2296 63.4028 45.7438V4.49219C63.4028 2.0064 61.5167 0 59.1792 0L4.23092 0C1.89342 0 0 2.0064 0 4.49219L0 45.7413C0 48.2271 1.89342 50.2436 4.23092 50.2436H25.3148C25.3148 50.2436 26.2297 59.2457 18.922 59.2457V63.7481H25.3148H38.0905H44.4881V59.2457C36.8973 59.2457 38.0905 50.2436 38.0905 50.2436L52.562 50.2461C50.6405 71.5 50.686 71 50.8042 69.7014C50.8042 75.8914 50.6948 76.8636 51.5 78C52.0661 78.8016 51.1613 87.1376 51.8054 87.3684L51.3272 87.9417L51.2686 88.0178C48.6749 92.1599 47.3695 95.8988 50.8538 99.2343L54.3113 102.542L55.0018 103.201L59.3718 107.384C63.2928 111.133 69.3732 110.816 72.921 106.666C76.4711 102.529 75.1826 93.678 71.2616 89.9265ZM10.7749 39.5597H9.45491V27.9348H10.7774L10.7749 39.5597ZM31.9881 47.4458C30.5705 47.4458 29.4212 46.2333 29.4212 44.7368C29.4212 43.2352 30.5729 42.0252 31.9881 42.0252C33.4082 42.0252 34.555 43.2377 34.555 44.7368C34.555 46.2359 33.4057 47.4458 31.9881 47.4458ZM22.4746 39.5597L22.4722 27.8815H23.7434V31.5367C23.7434 31.5417 23.7434 31.5519 23.7434 31.557C23.7434 32.6933 24.6194 33.6217 25.693 33.6217C26.0126 33.6217 26.2981 33.5202 26.5665 33.3807L26.5738 33.3909L29.9458 31.0015L31.7221 29.7459L32.9934 28.848C32.9934 28.8378 32.9958 28.8378 33.0007 28.8378C33.6448 28.158 33.7644 27.1409 33.3618 26.3469L40.2669 21.3956L38.3467 27.7243H40.2084L41.0599 24.7641H44.1807L45.0737 27.7243H47.0232L46.8134 27.0394C47.1916 27.5416 47.7894 27.8968 48.5921 27.8968C49.5315 27.8968 50.2782 27.4757 50.7027 26.8898H50.7466L50.8784 27.7243H52.5059C52.4156 27.2601 52.3887 26.593 52.3887 25.9132V23.2016C52.3887 21.5504 51.7275 20.0132 49.4412 20.0132C48.314 20.0132 47.3917 20.3379 46.8622 20.6778L47.216 21.9156C47.6967 21.5909 48.4335 21.3601 49.1362 21.3601C50.3953 21.3601 50.5856 22.1769 50.5856 22.6715V22.7983C47.9895 22.7806 46.4108 23.7318 46.3596 25.5632L43.8147 17.2814H41.5138L40.6817 20.0361L32.8201 25.6773C32.4932 25.4211 32.115 25.2867 31.7246 25.2714C31.1829 25.2486 30.629 25.4439 30.2142 25.8878C30.2142 25.8878 30.2069 25.898 30.202 25.898L29.9483 26.0857L27.6498 27.742V27.0394C27.2228 21.6772 21.3376 21.7584 21.3376 21.7584H18.7951L16.6504 25.4845L14.4983 21.7584H12.051C5.84862 21.7584 5.8047 26.4027 5.8047 28.158H5.80226V39.5572H4.53104V4.7839H58.8815V39.5597H22.4746ZM42.4458 19.3968C42.4946 19.1939 42.5434 18.991 42.5874 18.8033H42.6166C42.7655 19.407 42.9241 20.1198 43.1168 20.7564L43.8903 23.3285H41.3552L42.1164 20.7564C42.1848 20.4926 42.2531 20.2035 42.3214 19.9168L42.7264 19.6353L42.4458 19.3968ZM48.1407 25.4439C48.1407 24.3025 49.3583 24.0184 50.632 24.0362V25.0736C50.632 25.2131 50.632 25.3501 50.588 25.4896C50.4124 26.0349 49.8975 26.527 49.1655 26.527C48.5946 26.5296 48.1407 26.1897 48.1407 25.4439ZM51.7468 98.1943C48.7554 95.3408 50.1462 92.3933 52.3544 88.8345L53.9453 86.9398C57.0904 84.1318 60.2746 82.8027 63.3319 85.7248L66.3452 88.6088C65.6059 91.2037 64.2834 93.6311 62.4095 95.8176C59.8939 98.7575 56.9708 100.599 55.2311 101.527L51.7468 98.1943ZM71.9377 105.73C68.8779 109.297 63.6442 109.576 60.2672 106.344L56.617 102.851C59.4889 101.172 61.9264 99.1734 63.8687 96.9109C66.1403 94.2576 67.2919 91.7439 67.8702 90.0622L71.3569 93.3952C74.7314 96.6242 74.9949 102.156 71.9377 105.73Z",
    fill: "url(#paint3_linear_101_52)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_52",
    x1: 0,
    y1: 32,
    x2: 64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_52",
    x1: 0.280901,
    y1: 29.6024,
    x2: 75.5515,
    y2: 29.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_52",
    x1: -0.239187,
    y1: 20.254,
    x2: 78.1636,
    y2: 19.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_52",
    x1: -0.0902671,
    y1: 37.0093,
    x2: 75.938,
    y2: 37.0093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineClass);
export default __webpack_public_path__ + "static/media/online-class.26204a64c25a2da504798e4933e55ed8.svg";
export { ForwardRef as ReactComponent };